import { render, staticRenderFns } from "./AceEditor.vue?vue&type=template&id=60374de7&"
import script from "./AceEditor.vue?vue&type=script&lang=ts&"
export * from "./AceEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports